<template>
  <div class="newPatient-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span>{{$t('Patient Profile')}}</span>
          </div>
        </div>
        <hr class="small-hr">
        <div class="item-wrap">
          <div class="item"><span :class="{'es2':isIt||isFr}">{{$t('uername')}}:</span><label class="ID">{{profile.username}}</label></div>
          <div class="item portrait">
            <span class="long-portrait">{{$t('Portrait')}}:</span>
            <img :src="portrait">
          </div>
          <div class="item">
            <span  :class="{'es2':isFr||isSw}">{{$t('fullName')}}</span>
            <input class="name" v-model="profile.realname" >
          </div>

          <div class="item">
            <span>{{$t('gender')}}</span>
            <select class="gender" :value="profile.gender" v-model="profile.gender" id="gender">
              <option  value="GDRNF">{{$t('GDRNF')}}</option>
              <option  value="GDRM">{{$t('GDRM')}}</option>
              <option  value="GDRF">{{$t('GDRF')}}</option>
            </select>
          </div>
          <div class="item">
            <span>{{$t('height')}}</span>
            <input v-model="profile.height" class="height" :placeholder='profile.height'>
            <span class="unit">{{$t('cm')}}</span>
          </div>
          <div class="item">
            <span>{{$t('weight')}}</span>
            <input v-model="profile.weight" class="height" :placeholder='profile.weight'>
            <span class="unit">{{$t('kg')}}</span>
          </div>
          <div class="item spe-item">
            <span :class="{'es2':isEs||isIt||isPo||isFr||isCz}">{{$t('birthday')}}</span>
            <div class="block">
              <el-date-picker v-model="birthday"   type="date" :placeholder="birthdayShow"
                              :clearable=false  :picker-options="pickerOptions"  format="dd/MM  yyyy">
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <label class="spe-span">{{$t('disType')}}</label>
            <select class="weight" :value="profile.diabetes_type" id="dis_type">
              <option value="DBTNF">{{$t('DBTNF')}}</option>
              <option selected value="DBT1">{{$t('DBT1')}}</option><option value="DBT2">{{$t('DBT2')}}</option>
              <option value="DBTLADA">{{$t('LADA')}}</option><option value="DBTGEST">{{$t('Gestational')}}</option>
              <option  value="DBTPRE">{{$t('Prediabetes')}}</option>
              <option value="OTR">{{$t('Other')}}</option>
            </select>
          </div>
          <div class="item">
            <label class="spe-span">{{$t('disDate')}}</label>
            <div class="block">
              <el-date-picker v-model="profile.diabetes_diagonosis_date" type="date" :placeholder="disDateShow"
                              :clearable=false      :picker-options="pickerOptions"  format="dd/MM  yyyy">
              </el-date-picker>
            </div>
          </div>

          <div class="item"><span class="addSpan">{{$t('Address')}}</span>
            <input class="address" v-model="profile.address" >
            <input class="address" v-model="address2">
          </div>

          <div class="item post"><span>{{$t('Postcode')}}</span><input class="name" v-model="profile.zipcode" ></div>
          <div class="item"><span>{{$t('Mobile')}}</span><input class="name" v-model="profile.mobile" ></div>
          <div class="item"><span >{{$t('Telephone')}}</span><input class="name" v-model="profile.telephone" ></div>
          <div class="item email"><span >{{$t('Email')}}</span><input class="name" v-model="profile.email" ></div>
        </div>
        <hr class="small-hr">
        <div class="footer">
          <div class="item1">
            <span :class="{'es1':isEs||isDe||isPo||isCz}">{{$t('Inpatient')}}</span>
            <select v-model="profile.inHospital">
              <option>{{$t('Yes')}}</option><option>{{$t('No')}}</option>
            </select>
          </div>
          <div class="item1"><span :class="{'po1':isPo||isCz}">{{$t('Pno')}}</span><input v-model="profile.patientNo"></div>
          <div class="item1 spe-item1"><span :class="{'po1':isPo||isCz}">{{$t('Bno')}}</span><input v-model="profile.bedNo" ></div>
        </div>
        <div class="operate">
          <button class="cancel" @click="back">{{$t('Cancel')}}</button>
          <button class="create" @click="save">{{$t('save')}}</button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth/auth'
      import format from '@/lib/format'
  export default{
    data(){
      return{
        realname:'',gender:'',height:'',weight:'',username:'',birthdayShow:'',alias:'',isEs:false,isDe:false,isIt:false,isPo:false,
        birthday:'',
        birthday_d:'', birthday_m:'', birthday_y:'',isFr:false,isSw:false,isCz:false,
        diabetes_type:'',diabetes_diagnosis_date:'',disDateShow:'',
        address1:'', address2:'', postcode:'', mobile:'', telephone:'', email:'',
        inHospital:'', patientNo:'', bedNo:'',
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },
        isA:false,profile:'',value2:'',value3:'',
      }
    },
    computed:{
      portrait(){
        return '/api/v2.0/person/'+parseInt(sessionStorage.getItem('patientId'))+'/portrait'
      }
    },
    methods:{
      back(){
        this.$router.push('/monitor')
      },
      save(){
        let bthday = '';
        this.profile.birthday = this.birthday;
        if(typeof this.profile.birthday!== 'string'&&this.profile.birthday!==undefined){
          bthday =format.formatterDate3(this.profile.birthday.getTime()/1000);
        }else{
          bthday =this.profile.birthday;
        }
        let diagonosis_date = '';
        if(typeof this.profile.diabetes_diagonosis_date!== 'string'&&this.profile.diabetes_diagonosis_date!==undefined){
          diagonosis_date =format.formatterDate3(this.profile.diabetes_diagonosis_date.getTime()/1000);
        }else{
          diagonosis_date =this.profile.diabetes_diagonosis_date;
        }

        const obj1 =document.getElementById('dis_type');
        let dis_type = obj1.value;
        const obj2 =document.getElementById('gender');
        let gender = obj2.value;

        let info = {
          realname:this.profile.realname,
          gender:gender,
          height:this.height||this.profile.height,
          weight:this.weight||this.profile.weight,
          birthday:bthday,

          diabetes_type:dis_type,
          diabetes_diagonosis_date: diagonosis_date,

          address:this.profile.address,
          zipcode:this.profile.zipcode,
          mobile:this.profile.mobile,
          telephone:this.profile.telephone,
          email:this.profile.email,
          inHospital:this.profile.inHospital,
          patientNo:this.profile.patientNo,
          bedNo:this.profile.bedNo,
        };
        let Pid = parseInt(sessionStorage.getItem('patientId'));
        auth.modifyPatientProfile(this,Pid,info);
      }
    },
    mounted(){
      let Pid = parseInt(sessionStorage.getItem('patientId'));
      let lang = sessionStorage.getItem('language');
      this.isEs = (lang==='es')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      auth.getPatientProfile2(this,Pid);
    },
  }
</script>
<style scoped>
  .newPatient-container{
    height:100%;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:100%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  .main-container{
    width:97%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto 15px;
    border:none;
  }

  .item-wrap{
    width:96%;
    margin:0 auto;
  }
  .item{
    width:95%;
    height:37px;
    line-height: 37px;
    margin-bottom: 15px;
  }
  .item span{
    width:100px;
    height: 100%;
    float: left;
    display: inline-block;
  }
  .ID{
    color:#0082d2;
    margin-left: 44px;
  }
  .portrait{
    margin-bottom: 15px;
  }
  .item .long-portrait{
    width: 120px;
  }
  .portrait img{
    background:#c9c9c9;
    border-radius:100px;
    width:51px;
    height:50px;
    margin-left: 30px;
    margin-top: -10px;
  }
  .item .name{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:298px;
    height:35px;
    font-size:18px;
    margin-left: 40px;
    padding-left:8px;
    color:#282828;
    font-family:SFUIText-Regular;
  }
  .item select{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:159px;
    height:35px;
    font-size:16px;
    margin-left: 40px;
    color:#282828;
    padding-left: 6px;
    font-family:SFUIText-Regular;
  }
  .item option{
    color: #282828;
    font-family:SFUIText-Regular;
  }
  .item .height{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:151px;
    height:34px;
    font-size:16px;
    margin-left: 40px;
    color:#282828;
    padding-left: 6px;
    font-family:SFUIText-Regular;
  }
  .item .spe-span{
    height:20px;
    line-height: 20px;
    width:80px;
    display: block;
    float: left;
    margin-right: 20px;
  }
  .item .addSpan{
    height:60px;
  }
  .item .address{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:60%;
    height:35px;
    margin-left: 40px;
    margin-bottom: 12px;
    padding-left: 8px;
    color:#282828;
    font-size: 16px;
    font-family:SFUIText-Regular;
  }
  .post{
    clear: both;
    margin-top: 65px;
    margin-top: 65px;
  }
  .email{
    margin-bottom: 30px;
  }
  .item .unit{
    float:none;
    margin-left: 4px;
    font-size: 18px;
  }
  .item .es2{
    width:100px;
    height: 20px;
    line-height: 20px;
    float: left;
    display: inline-block;
    margin:0;
  }

  .item .block{
    margin-left: 40px;
    float: left;
  }
  .el-date-editor.el-input{
    width:159px;
    color:#282828;
  }

  .footer{
    width:96%;
    margin:0 auto;
    margin-bottom: 60px;
  }
  .item1{
    float: left;
    width:30%;
    margin-right: 4%;
  }
  .item1 select,.item1 input{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:45%;
    height:35px;
    margin-left: 20%;
    padding-left: 6px;
    color:#282828;
    font-family:SFUIText-Regular;
    font-size: 16px;
  }
  .item1 input{
    width:50%;
    margin-left: 5%;
    padding-left: 8px;
  }
  .spe-item1{
    margin-right: 0;
  }
  .es1{
    width:50px;
    float: left;
  }
  .po1{
    width:90px;
    float: left;
  }
  .operate{
    width: 50%;
    float: right;
    margin-top:50px;
    margin-bottom: 20px;
    margin-right: 10px;
  }
  .operate button{
    background: transparent;
    border:1px solid #a3a3a3;
    border-radius:100px;
    width:150px;
    height:30px;
    outline: none;
    cursor: pointer;
    float: right;
  }
  .operate .create{
    margin-right: 20px;
  }

</style>



// WEBPACK FOOTER //
// patientProfile-edit.vue?1b7ad25d